import type { JSX } from 'react';

import { Link } from '@change/core/react/router';

import { Avatar } from '@change-corgi/design-system/components/media';
import { Text } from '@change-corgi/design-system/typography';

import type { DecisionMaker } from '../../../hooks/decisionMakers';
import type { AllDmResponses } from '../hooks/useDecisionMakers';

import { DecisionMakerListItem } from './DecisionMakerListItem';

type Props = {
	allDmResponses: AllDmResponses;
	decisionMaker: DecisionMaker;
};

export function LoadedDecisionMakerListItem({ decisionMaker, allDmResponses }: Props): JSX.Element {
	const photoUrl = decisionMaker.photo?.userMedium.processing ? undefined : decisionMaker.photo?.userMedium.url;

	return (
		<DecisionMakerListItem
			photoContent={
				<Avatar variant="subtle" data-testid="dm-image" src={photoUrl} mr={10} size={50} alt="" loading="lazy" />
			}
			decisionMaker={decisionMaker}
			allDmResponses={allDmResponses}
		>
			{decisionMaker.publiclyVisible ? (
				<Link
					sx={{ fontWeight: 'bold' }}
					data-testid="dm-link"
					to={`/decision-makers/${decisionMaker.slug || decisionMaker.id}`}
				>
					<Text size="large" fontWeight="semibold" ellipsis>
						{decisionMaker.displayName}
					</Text>
				</Link>
			) : (
				<Text size="large" fontWeight="semibold" ellipsis>
					{decisionMaker.displayName}
				</Text>
			)}

			{decisionMaker.title && (
				<Text size="small" ellipsis>
					{decisionMaker.title}
				</Text>
			)}
		</DecisionMakerListItem>
	);
}
